import React from "react";
import { CustomFieldDefinition, CustomFieldType } from "../types/customFields";

export const FIELD_TYPE_LABELS: Record<CustomFieldType, string> = {
  text: "Text",
  number: "Number",
  select: "Select",
  date: "Date",
  boolean: "Boolean",
};

export function renderInput(
  def: CustomFieldDefinition,
  value: string | number | boolean | null | undefined,
  onChange: (val: string | number | boolean | null) => void,
  style?: React.CSSProperties
) {
  const inputStyle: React.CSSProperties = {
    padding: "4px 8px",
    border: "1px solid #d1d5db",
    borderRadius: "4px",
    fontSize: "14px",
    width: "100%",
    boxSizing: "border-box",
    ...style,
  };

  switch (def.field_type) {
    case "text":
      return (
        <input
          type="text"
          value={(value as string) || ""}
          onChange={(e) => onChange(e.target.value || null)}
          style={inputStyle}
        />
      );
    case "number":
      return (
        <input
          type="number"
          value={value !== null && value !== undefined ? String(value) : ""}
          onChange={(e) => onChange(e.target.value ? parseFloat(e.target.value) : null)}
          style={inputStyle}
        />
      );
    case "select":
      return (
        <select
          value={(value as string) || ""}
          onChange={(e) => onChange(e.target.value || null)}
          style={inputStyle}
        >
          <option value="">—</option>
          {(def.options?.choices || []).map((choice) => (
            <option key={choice} value={choice}>{choice}</option>
          ))}
        </select>
      );
    case "date":
      return (
        <input
          type="date"
          value={(value as string) || ""}
          onChange={(e) => onChange(e.target.value || null)}
          style={inputStyle}
        />
      );
    case "boolean":
      return (
        <select
          value={value === null || value === undefined ? "" : String(value)}
          onChange={(e) => onChange(e.target.value === "" ? null : e.target.value === "true")}
          style={inputStyle}
        >
          <option value="">—</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      );
    default:
      return null;
  }
}
